import CircularProgress from '@mui/material/CircularProgress';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
    root: {
        position: 'relative',
        '& .MuiCircularProgress-root': {
            position: 'absolute',
            top: 0,
            left: 0,
        },
    },
}));

type Props = IconButtonProps & {
    tooltip: string;
    showLoading: boolean;
};

export default function IconButtonLoading({ tooltip, showLoading, children, ...props }: Props) {
    const { classes } = useStyles();

    return (
        <div className={classes.root}>
            <Tooltip title={tooltip}>
                <span>
                    <IconButton {...props} disabled={props.disabled || showLoading} size="large">
                        {children}
                    </IconButton>
                </span>
            </Tooltip>
            {showLoading && (
                <CircularProgress
                    data-testid="icon_button_loading_spinner"
                    size={props.size && props.size === 'small' ? 30 : 48}
                    color="inherit"
                />
            )}
        </div>
    );
}
